import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// Components
import Heading from '../../Heading';
import Button from '../../Button';
import AddressesField from '../../AddressFieldGroup/partials/AddressesField';
import useRestaurantSelector from '../useRestaurantSelector';

// Assets
import pinIconLight from '../assets/pin-green_light.svg';
import metroIcon from '../assets/metro.svg';

// Icons
import PointerIcon from '../../../icons/pointer.svg';

// Config
import config from '../../../config';

// Styles
import styles from './RestaurantSelector.styl';

const cx = classNames.bind(styles);

export default function RestaurantSelector(props) {
  const { className, onSuccessCallback } = props;

  const intl = useIntl();

  const {
    buttonRef,
    isMapLoaded,
    selectedRestaurant,
    restaurantAddress,
    setRestaurantAddress,
    //
    handleOnAccept,
    handleOnRestaurantSearchClick,
    //
    isButtonExist,
    yMap,
    googleMap,
  } = useRestaurantSelector(onSuccessCallback);

  return (
    <div className={cx('RestaurantSelector', className)}>
      {/* Выберите ресторан на карте */}
      <Heading className={cx('RestaurantSelector__title')} level={3} medium>
        {intl.formatMessage({ id: 'order.pickup.selectRestaurant.search' })}
      </Heading>
      <form className={cx('RestaurantSelector__search')} autoComplete="off">
        {/* Адрес */}
        <AddressesField
          className={cx('RestaurantSelector__search-input')}
          onAddressSelect={address => handleOnRestaurantSearchClick(address)}
          newest
          input={{
            name: 'restaurantAddress',
            value: restaurantAddress,
            onChange: value => setRestaurantAddress(value),
            placeholder: intl.formatMessage({ id: 'page.contacts.searchAddress.placeholder' }),
          }}
        />
        <Button
          className={cx('RestaurantSelector__search-button')}
          small
          onClick={() => handleOnRestaurantSearchClick(restaurantAddress)}
        >
          <PointerIcon />
        </Button>
      </form>
      <div className={cx('RestaurantSelector__map')}>
        {!isMapLoaded && <div className={cx('RestaurantSelector__preloader')} />}
        {config.legal === 'pl' ? googleMap : yMap}
      </div>
      {/* Выбранный ресторан */}
      {selectedRestaurant && (
        <div className={cx('RestaurantSelector__info')}>
          <div className={cx('RestaurantSelector__address')} level={4}>
            <img className={cx('RestaurantSelector__info-icon')} src={pinIconLight} alt="pin" />
            {`- ${selectedRestaurant.address}`}
          </div>
          {selectedRestaurant.metro && (
            <div className={cx('RestaurantSelector__metro')}>
              <img className={cx('RestaurantSelector__info-icon')} src={metroIcon} alt="pin" />
              {`- ${intl.formatMessage({
                id: 'map.infoWindow.metro',
              })} ${selectedRestaurant.metro.split(';').join('; ')}`}
            </div>
          )}
          {selectedRestaurant.open && (
            <div className={cx('RestaurantSelector__schedule')}>
              {Object.keys(selectedRestaurant.open).map(day => (
                <div key={day} className={cx('RestaurantSelector__schedule-wrapper')}>
                  <div className={cx('RestaurantSelector__schedule-day')}>{day}</div>
                  <div className={cx('RestaurantSelector__schedule-time1')}>
                    {selectedRestaurant.open[day].split(' - ')[0]}
                  </div>
                  <div className={cx('RestaurantSelector__schedule-time2')}>
                    {selectedRestaurant.open[day].split(' - ')[1]}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {isButtonExist && (
        <Button
          className={cx('RestaurantSelector__accept')}
          onClick={handleOnAccept}
          disabled={!selectedRestaurant}
          buttonRef={buttonRef}
        >
          {intl.formatMessage({ id: 'button.accept' })}
        </Button>
      )}
    </div>
  );
}

RestaurantSelector.defaultProps = {
  className: '',
  onSuccessCallback: undefined,
};

RestaurantSelector.propTypes = {
  className: PropTypes.string,
  onSuccessCallback: PropTypes.func,
};
